import http from "../../../libs/http"
import appStore from "../../../stores/appStore";
import { StoreLocation } from "../../../types/common";
import { Product } from "../../../types/product";
const homeService = {
    fetchPopularNow: async () => {
       const { data } = await http.get('/api/products/popular', {
        params: {
            city: appStore.selectedCity ?? ''
        }
       });

       return data as Product[];
    },

    fetchStoreLocation: async () => {
        const { data } = await http.get('/api/misc/store-locations');

        return data as StoreLocation[];
    }
}

export default homeService;